<div class="navblock hidden-print">
  <button (click)="openCreateModal()" class="btnadd">{{'Add driver'|translate}}</button>

  <app-group-filter #groupFilter></app-group-filter>

  <div class="inputgroup">
    <input class="searchinput" type="text" placeholder="{{'Find by name' | translate }}" [(ngModel)]="nameFilter"
           (input)="onTermChange($event)" />
  </div>
  <div></div>
  <button (click)="openPenaltyModal()" class="btn_orange">{{'Violations'|translate}}</button>
</div>

<div class="tablewrap">
  <div class="table">
    <table fixedcols="[0, 4]" id="exporttable">
      <tr>
        <th class="hidden-print">
            <switch-all-checkbox [items]="objects | groupFilter : filter" />
        </th>
        <th>{{'Name' | translate}}</th>
        <th>{{'Internal ID' | translate}}</th>
        <th>{{'Phone №' | translate}}</th>
        <th>{{'Category' | translate}}</th>
        <th>{{'Class' | translate}}</th>
        <th class="hidden-print">&nbsp;</th>
      </tr>
      <tr *ngFor="let driver of objects | groupFilter : filter | pagesfilter: pageInfoFilter">
        <td class="hidden-print">
          <input type="checkbox" [(ngModel)]="driver.IsChecked" />
        </td>
        <td>{{driver.Name}}</td>
        <td>{{driver.InternalId}}</td>
        <td>{{driver.Phone}}</td>
        <td>{{driver.Category}}</td>
        <td>{{driver.Rank}}</td>
        <td class="hidden-print">
          <button class="btn_img btn_edit" (click)="openEditModal(driver)" data-toggle="tooltip" data-placement="top" title="{{'Edit'|translate}}"></button>
          <button class="btn_img btn_trush" (click)="deleteObject(driver.Id)" title="{{'Delete'|translate}}"></button>
        </td>
      </tr>
    </table>
  </div>
</div>
<app-footer-component (onDeleteSelected)="deleteSelected()"
                      [viewMode]="'print excel pages'" (onPageChange)="onPageChange($event)"
                      [items]="objects | groupFilter : filter">
  <div export style="display:inline-block" *ngIf="usersService.InterfaceIsPermitted(InterfacePermissions.DATAINFO)">
    <div class="btn_img btn_graygray dropup btn_export-import dropclick">
      <ul>
        <li (click)="myInput.click()">
          {{'Import'|translate}}
          <input type="file" #myInput class="btn_blue" style="visibility:hidden;display:none"
                 (change)="importDrivers($event)" onclick="this.value=null" accept=".wlp">
        </li>
      </ul>
    </div>
  </div>

</app-footer-component>
<template #mgmtDialog></template>
<template #groupMgmtDialog></template>
<template #objectsListDialog></template>
